var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"7","viewBox":"0 0 10 7"}},[_c('path',{attrs:{"d":"M5,0l5,7H0Z","fill":"#01456a"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }